/**
 * /devhub/resources — Area D (Resources & Files). REQ-001.91 DevHub UI rebuild · Phase 1 IA shell.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DevHubAreaShell } from '../components/devhub/DevHubAreaShell';

export const Route = createFileRoute('/devhub/resources')({ component: DevHubResources });

function DevHubResources() {
  return (
    <DevHubAreaShell
      title="Resources & Files"
      subtitle="Activation ledger, worker registry, file classes, real upload + preview, and the storage treemap."
      pages={[
        { label: 'Resource activation', description: '8-level resource activation; governed promote (operator GO).', status: 'live', to: '/devhub/activation' },
        { label: 'Worker Registry', description: 'Registration vs live process; links to Runtime Control.', status: 'live', to: '/devhub/workers' },
        { label: 'File ingestion', description: 'Workspace file ingestion + classification pipeline.', status: 'live', to: '/devhub/file-ingestion' },
        { label: 'Report templates', description: 'Reusable report layouts and data-merge templates.', status: 'live', to: '/devhub/report-templates' },
        { label: 'Remote database', description: 'Remote SQLite / local dev database projection.', status: 'live', to: '/devhub/remote-db' },
        { label: 'Script runtime', description: 'Registered script routes and their classification.', status: 'live', to: '/devhub/scripts' },
        { label: 'Files & Preview', description: 'Live project scope + preview-by-type; storage_uri never exposed; preview-gen worker-gated.', status: 'live', to: '/devhub/files' },
        { label: 'Storage Treemap', description: 'Project folder map (TreemapChart); node → detail.', status: 'Phase 4' },
      ]}
    />
  );
}
